import { Link } from "react-router-dom";
import { useTranslation } from "../../../../i18n/LanguageProvider";
import { buildWomanImageAlt } from "../../../../utils/imageAlt";
import { toWomanSlug } from "../../../../utils/slug";
import "./WomanCard.sass";

function WomanCard({ id, name, surname, domain, categoryColor, image }) {
    const { localizedPath } = useTranslation();
    const slug = toWomanSlug(name, surname, id);
    const imageAlt = buildWomanImageAlt({ name, surname, category: domain });

    return (
        <Link to={localizedPath(`/femeie/${slug}`)} className="woman-card card-common">
            <div className="woman-card__image">
                <img src={image} alt={imageAlt} />
            </div>

            <div className="woman-card__content">
                <h3 className="woman-card__name">
                    {name} {surname}
                </h3>

                <span
                    className="woman-card__domain"
                    style={categoryColor ? { backgroundColor: categoryColor } : undefined}>
                    {domain}
                </span>
            </div>
        </Link>
    );
}

export default WomanCard;
